export enum Icon{
    ExclamationTriangle = 'exclamation_triangle',
    Exclamation = 'exclamation',
    Close = 'close'
}
